import { ActionIcon, Group, Text } from "@mantine/core";
import IconX from "@tabler/icons-react/dist/esm/icons/IconX.mjs";

import { useDeleteEntityFieldFunctionMutation } from "../../hooks/mutations";
import classes from "./FieldFunctionBox.module.scss";

export default function FieldFunctionBox({
  ruleId,
  functionData,
  content,
  canEdit = true,
}) {
  const { mutate: deleteFunction } = useDeleteEntityFieldFunctionMutation({
    ruleId,
  });

  return (
    <div className={classes.wrapper}>
      <Group justify="space-between" gap="xs" wrap="nowrap" mb={4}>
        <Text size="sm" c="dark">
          Function {functionData?.function?.name}
        </Text>
        {canEdit && (
          <ActionIcon
            variant="subtle"
            color="red"
            size="sm"
            aria-label="Remove function"
            onClick={(ev) => {
              ev.stopPropagation();
              deleteFunction({ id: functionData.id });
            }}
          >
            <IconX size={14} stroke={1.5} />
          </ActionIcon>
        )}
      </Group>
      {content}
    </div>
  );
}
